import React from 'react';

const Footer = () => (
    <footer className="footer">
        <div className="inner footer__inner">
            <a href="http://www.solmecke.eu/blog">Wissenswertes</a>
            <span className="footer__separator">&nbsp;|&nbsp;</span>
            <a href="http://www.solmecke.eu/impressum">Impressum</a>
            <span className="footer__separator">&nbsp;|&nbsp;</span>
            <a href="http://www.solmecke.eu/kontakt">Kontakt</a>
            <span className="footer__separator">&nbsp;|&nbsp;</span>
            <a href="http://www.solmecke.eu/datenschutzerklaerung/">Datenschutz</a>
            <span className="footer__separator">&nbsp;|&nbsp;</span>
            <a href="http://www.solmecke.eu">solmecke.eu</a>
        </div>
    </footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/layouts/footer.js